import React from "react";
import { useImage } from "@/hooks/useImage";

/**
 * Smart image component that reads from the CMS image registry and falls back
 * to the default URL when no admin override is set.
 *
 * Always renders with:
 *   - loading="lazy" + decoding="async" for performance
 *   - object-cover by default so cards stay aligned even when sources vary
 *   - sensible default `sizes` to encourage the browser to pick the smallest variant
 *
 * Usage:
 *   <Img imageKey="founder.shubham"
 *        defaultSrc="https://..." defaultAlt="..."
 *        className="w-full h-full object-cover" />
 */
export default function Img({
  imageKey,
  defaultSrc,
  defaultAlt = "",
  alt: altOverride,
  className = "",
  style,
  fit = "cover",
  position = "center center",
  loading = "lazy",
  sizes,
  draggable = false,
  ...rest
}) {
  const { url, alt } = useImage(imageKey, defaultSrc, defaultAlt);
  return (
    <img
      src={url}
      alt={altOverride ?? alt}
      loading={loading}
      decoding="async"
      sizes={sizes}
      draggable={draggable}
      className={className}
      style={{
        objectFit: fit,
        objectPosition: position,
        ...(style || {}),
      }}
      {...rest}
    />
  );
}
